import {AxiosResponse} from "axios";
import {$api} from "../api/api.ts";
import {getToken} from "../../utils/Utils.ts";
import {
    AvailableChannelsType,
    FilteredChannelParams,
    IChannelResponseData,
    ICreateChannelParams,
    IEditChannelParams, IPrecheckChannelData
} from "../models/ChannelResponse.ts";
import qs from 'qs';
import {IUserBlackListParams} from "../models/UserResponse.ts";

export const ChannelService = {
    fetchChannelsData(): Promise<AxiosResponse<IChannelResponseData[]>> {
        return $api.get('/channels', {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchChannelsDataWithQuery(params:string[]): Promise<AxiosResponse<IChannelResponseData[]>> {
        return $api.get('/channels', {
            params:  { channels: params },
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchFilteredChannelsData(params:FilteredChannelParams): Promise<AxiosResponse<AvailableChannelsType>> {
        return $api.get('/channels/search', {
            params,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    createNewChannel(data: ICreateChannelParams): Promise<{ data:IChannelResponseData }> {
        return $api.post('/channels', data, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    editChannel(id: string, data: IEditChannelParams): Promise<{ data: IChannelResponseData }> {
        return $api.patch(`/channel/${id}`, data, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    checkTelegramUsername(channel_username:string): Promise<{ data: IPrecheckChannelData }> {
        return $api.get(`/channel_precheck/${channel_username}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    getCurrentChannel(id: string): Promise<{ data: IChannelResponseData }> {
        return $api.get(`/channels/${id}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    deleteChannel(id: string): Promise<IChannelResponseData> {
        return $api.delete(`/channels/${id}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    setChannelToBlackList(data: IUserBlackListParams): Promise<AxiosResponse> {
        return $api.post('/user/blacklist', data, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    removeChannelFromBlackList(channelId:string): Promise<AxiosResponse> {
        return $api.delete(`/user/blacklist/${channelId}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    setChannelToFavourites(data: IUserBlackListParams): Promise<AxiosResponse> {
        return $api.post('/user/favourites', data, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    removeChannelFromFavourites(channelId:string): Promise<AxiosResponse> {
        return $api.delete(`/user/favourites/${channelId}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    getBlackListChannel(params:FilteredChannelParams): Promise<AxiosResponse> {
        return $api.get(`/user/blacklist`,  {
            params,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    getFavouritesChannels(params:FilteredChannelParams): Promise<AxiosResponse> {
        return $api.get(`/user/favourites`,  {
            params,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
}
